// extracted by mini-css-extract-plugin
export default {"icon":"NotificationsP2PDetailsType_icon__b3iDg"};